module.exports = "https://img.xiyuyouxi.com/saas/img/shop_item_bg.69abcbb5.png";